import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { KYMW4100Component } from './kymw4100.component';
import { SharedModule } from '../../../shared/shared.module';
import { FileDownloadService } from '../../../commons/kymw02/file-download-confirm/file-download.service';
import { KYMW4101Module } from '../kymw4101/kymw4101.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { OutputGoodsLayoutInspectListService } from './api-services/output-goods-layout-inspect-list.service';

/**
 * モジュール設定クラス
 *
 * @export KYMW4100Module
 * @class KYMW4100Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    SharedModule,
    AppCommonsModule,
    KYMW4101Module,
  ],
  declarations: [
    KYMW4100Component,
  ],
  providers: [
    FileDownloadService,
    OutputGoodsLayoutInspectListService,
  ],
})
export class KYMW4100Module {

}
